import Button from 'components/Button';
import Error from 'components/form/Error';
import Input from 'components/form/Inputs/Input';
import ArrowRightIcon from 'components/icons/ArrowRight';
import { MentorshipStatusValues } from 'enums/MentorshipStatus';
import { FC, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { getLocaleDate } from 'utils/time';
import { ButtonsContainer, InputContainer } from '.';
import { MentoringContext } from '..';
import ChangeReferee from './ChangeReferee';

const Info = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Ongoing: FC = () => {
  const { mentorship } = useContext(MentoringContext);
  const [interruptLoading, setInterruptLoading] = useState(false);
  const [finishLoading, setFinishLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);

  const handleInterrupt = () => {
    setInterruptLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'INTERRUPTED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setInterruptLoading(false);
      });
  };

  const handleFinish = () => {
    setFinishLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'FINISHED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setFinishLoading(false);
      });
  };

  return (
    <div>
      <Info>
        <InputContainer>
          <Input
            value={mentorship?.createdAt && getLocaleDate(mentorship.createdAt)}
            readOnly
            variant="disabled"
            label="Date du mentorat"
          />
        </InputContainer>
        <InputContainer>
          <Input
            value={
              !!mentorship?.interviews?.length && mentorship.interviews[0].date
                ? getLocaleDate(mentorship.interviews[0].date)
                : ''
            }
            readOnly
            variant="disabled"
            label="Date du dernier entretien"
          />
        </InputContainer>
        <InputContainer>
          <p>Mentor actuel</p>
          <Link
            to={`/admin/mentoring/mentors/${mentorship?.mentor?.id}/mentoring/ongoing/`}
          >
            <Input
              style={{ cursor: 'pointer' }}
              value={
                mentorship?.mentor?.firstName +
                ' ' +
                mentorship?.mentor?.lastName
              }
              icon={<ArrowRightIcon />}
              iconSide="right"
              readOnly
            />
          </Link>
        </InputContainer>
        <InputContainer>
          <ChangeReferee mentorship={mentorship} />
        </InputContainer>
      </Info>
      <ButtonsContainer>
        <Button
          color="primary"
          onClick={handleInterrupt}
          loading={interruptLoading}
        >
          Interrompre le mentorat
        </Button>
        <Button color="primary" onClick={handleFinish} loading={finishLoading}>
          Terminer le mentorat
        </Button>
      </ButtonsContainer>
      {error && <Error>Une erreur est survenue.</Error>}
    </div>
  );
};

export default Ongoing;
